import type { OrderProgressItem } from '../models/OrderProgressModel';

/** Snapshot row data for create-tab copy (no persisted id / audit fields). */
export const buildOrderProgressCopySource = (source: OrderProgressItem): OrderProgressItem => ({
  id: '',
  date: source.date,
  employee_ids: [...(source.employee_ids || [])],
  employee_names: [...(source.employee_names || [])],
  note: source.note || '',
  order_id: source.order_id,
  order_code: source.order_code || '',
  customer_name: source.customer_name,
  sales_employee_name: source.sales_employee_name,
  delivery_address_line: source.delivery_address_line,
  phone: source.phone,
  order_total_amount: source.order_total_amount,
  created_at: '',
});

export const buildOrderProgressCopyTabTitle = (source: OrderProgressItem, fallbackIndex: number): string => {
  const orderLabel = source.order_code?.trim();
  if (orderLabel) {
    return `Copy - ${orderLabel}`;
  }
  return `Copy - Tiến độ #${fallbackIndex}`;
};
